import { render, staticRenderFns } from "./ColorOption.vue?vue&type=template&id=bf065f6a&scoped=true&"
import script from "./ColorOption.vue?vue&type=script&lang=js&"
export * from "./ColorOption.vue?vue&type=script&lang=js&"
import style0 from "./ColorOption.vue?vue&type=style&index=0&id=bf065f6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf065f6a",
  null
  
)

export default component.exports